module.exports = __webpack_public_path__ + "img/title_start_btn.9cd8d064.png";